import { useEffect, useState } from "react";
import { ConfigProvider, Select } from "antd";
import { GET_API } from "../Functionalities/APIs";
import { picked_franchise_id, picked_franchise_name } from "../Functionalities/Config";
import { ALL_FRANCHISES, franchiseOptions } from "../Functionalities/franchisePicker";
import { savePickedFranchise } from "../Functionalities/pickedFranchise";
import "./franchiseSwitcher.css";

const THEME = {
  token: {
    colorPrimary: "#fb310d",
    borderRadius: 8,
    controlHeight: 32,
    fontSize: 13,
    fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  },
};

const savedPick = picked_franchise_id ? [{ id: picked_franchise_id, name: picked_franchise_name }] : [];

const FranchiseSwitcher = () => {
  const [franchises, setFranchises] = useState([]);

  useEffect(() => {
    GET_API("", "franchise_dropdown=true&page_wise=false", "/franchise/details/")
      .then((res) => {
        const list = res?.data;
        setFranchises(Array.isArray(list) ? list : list?.results || []);
      })
      .catch(() => setFranchises([]));
  }, []);

  const pick = (value) => {
    const chosen = franchises.find((f) => String(f.id) === value);
    savePickedFranchise(chosen ? { id: chosen.id, name: chosen.name } : null);
    window.location.reload();
  };

  return (
    <ConfigProvider theme={THEME}>
      <Select
        showSearch
        optionFilterProp="label"
        className={`franchise-switcher${picked_franchise_id ? " franchise-switcher--picked" : ""}`}
        aria-label="Franchise you are working for"
        title="Every page shows and saves for this franchise"
        value={picked_franchise_id || ALL_FRANCHISES}
        options={franchiseOptions(franchises.length ? franchises : savedPick)}
        onChange={pick}
        popupMatchSelectWidth={false}
      />
    </ConfigProvider>
  );
};

export default FranchiseSwitcher;
